import { formatDate } from "../../Utils/util-service";

export const columns = [
  {
    field: "createdAt",
    headerName: "Estimate Date",
    headerClassName: "table--header",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span>
        {params.row.createdAt ? formatDate(params.row.createdAt) : "--"}
      </span>
    ),
  },
  {
    field: "name",
    headerName: "Name",
    headerClassName: "table--header",
    headerAlign: "center",
    align: "center",
    flex: 2,
  },
  {
    field: "orderedBy",
    headerName: "Ordered By",
    headerClassName: "table--header",
    headerAlign: "center",
    align: "center",
    flex: 2,
    renderCell: (params) => (
      <span>
        {params.row.name} ({params.row.nickName})
      </span>
    ),
  },
  {
    field: "totalQuantity",
    headerName: "Total Qty.",
    headerClassName: "table--header",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return <span>{params.row.totalQuantity} </span>;
    },
  },
  {
    field: "totalAmount",
    headerName: "Total Amt.",
    headerClassName: "table--header",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return <strong>₹{params.row.totalAmount} </strong>;
    },
  },
  {
    field: "menu",
    headerName: "Action",
    headerClassName: "table--header",
    headerAlign: "center",
    align: "center",
    flex: 0.5,
  },
];
